import { useState, useContext } from 'react';
import { ErrorContext } from 'contexts';
// no need to share response state. just return
// for now if status is FAILURE throw error for easier processing in promise
const useApi = (promise) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { dispatch } = useContext(ErrorContext);
  const fetchData = async (...args) => {
    setIsLoading(true);
    dispatch({ type: 'removeError' });

    try {
      const response = (await promise(...args)).data;
      console.log('useApi', response);
      if (response.status === 'FAILURE') throw response.error;
      return response.data;
    } catch (ex) {
      const {
        response: {
          data: { error, message },
        },
      } = ex;
      dispatch({ type: 'showError' });
      setError({ error, message });
    } finally {
      setIsLoading(false);
    }
  };

  return [{ isLoading, error }, fetchData];
};

export { useApi };
